import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';
import React from 'react';

const SearchIcon = ({ width = 24, height = 24, color: colorProp, fill: fillProp, hovered }: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M18.7604 15.5291L20.3263 17.0369C21.2264 17.937 21.2264 19.4177 20.3263 20.325C19.4263 21.225 17.9456 21.225 17.0383 20.325L14.1164 17.4005'
        fill='none'
      />
      <path
        d='M18.7604 15.5291L20.3263 17.0369C21.2264 17.937 21.2264 19.4177 20.3263 20.325C19.4263 21.225 17.9456 21.225 17.0383 20.325L14.1164 17.4005L17.1936 14.0932L18.7604 15.5291Z'
        fill='none'
      />
      <path
        d='M18.7605 15.5291L20.3265 17.0369C21.2265 17.937 21.2265 19.4177 20.3265 20.325C19.4264 21.225 17.9457 21.225 17.0384 20.325L13.9827 17.2692'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.5474 18.0973C14.7164 18.0973 18.0961 14.7176 18.0961 10.5486C18.0961 6.37964 14.7164 3 10.5474 3C6.37842 3 2.99878 6.37964 2.99878 10.5486C2.99878 14.7176 6.37842 18.0973 10.5474 18.0973Z'
        fill={hovered ? fill : 'none'}
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />

      <path
        d='M8.80727 15.4764C7.3193 14.9538 6.14345 13.7779 5.62085 12.2899'
        stroke={color}
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default SearchIcon;
